/* Progressive placeholders: no artificial delay and no full-page overlay. */
(() => {
  'use strict';
  const finish = image => {
    if (!(image instanceof HTMLImageElement)) return;
    image.dataset.skeletonImage = 'ready';
    const frame = image.closest('[data-skeleton-media]');
    if (frame) frame.dataset.skeletonReady = 'true';
  };
  const scan = root => {
    const images = [...root.querySelectorAll('img:not([data-skeleton-image])')];
    if (root instanceof HTMLImageElement) images.unshift(root);
    images.forEach(image => { image.dataset.skeletonImage = image.complete ? 'ready' : 'pending'; });
    const frames = [...root.querySelectorAll('[data-skeleton-media]')];
    if (root.matches?.('[data-skeleton-media]')) frames.unshift(root);
    frames.forEach(frame => {
      const image = frame.querySelector('img');
      // Cached, failed, or absent images must never leave a loading animation.
      if (!image || image.complete) frame.dataset.skeletonReady = 'true';
    });
  };
  document.addEventListener('load', event => finish(event.target), true);
  document.addEventListener('error', event => finish(event.target), true);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('nirala:quick-order-mounted', event => scan(event.target));
  window.addEventListener('pageshow', () => scan(document));
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'childList') {
        record.addedNodes.forEach(node => { if (node instanceof Element) scan(node); });
        continue;
      }
      const { target } = record;
      if (!(target instanceof HTMLImageElement)) continue;
      target.dataset.skeletonImage = target.complete ? 'ready' : 'pending';
      const frame = target.closest('[data-skeleton-media]');
      if (frame) frame.dataset.skeletonReady = String(target.complete);
    }
  });
  observer.observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['src','srcset']});
  scan(document);
})();
